module.exports = __webpack_public_path__ + "img/section1Model.9b09026d.webp";